import { render } from "./noroute.vue?vue&type=template&id=a9d97f46&ts=true"
import script from "./noroute.vue?vue&type=script&lang=ts"
export * from "./noroute.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__